import React from "react";
import styled from "styled-components";
import { Avatar } from "@sonder/ui/source/styled/components/Avatar";
import { Invisible } from "@sonder/ui/source/styled/fragments/Invisible";
import {
  Cell,
  useTableContext,
} from "@sonder/ui/source/styled/fragments/Table";
import {
  GetQAEmailConfigurationsCompany,
  GetQAEmailConfigurationsUser,
} from "core/queries/GetQAEmailConfigurations";
import { RemoveQualityAuditConfigurationButton } from "quality_audits_email_configuration/components/RemoveQualityAuditConfigurationButton";

interface QualityAuditsEmailConfigurationRowProps {
  id: string;

  // TODO: Do not tightly couple these.
  company?: GetQAEmailConfigurationsCompany | null;
  user?: GetQAEmailConfigurationsUser | null;
}

const StyledAvatar = styled(Avatar)`
  margin-right: 1rem;
`;

export const QualityAuditsEmailConfigurationRow = (
  props: QualityAuditsEmailConfigurationRowProps,
) => {
  const { hovered } = useTableContext();
  const { id, company, user } = props;

  const { id: companyId, name: companyName } = company || {};
  const { id: userId, name: userName, avatar } = user || {};
  const { url: imageUrl } = avatar || {};

  return (
    <>
      <Cell rowStart rowKey={id}>
        {companyName}
      </Cell>
      <Cell rowKey={id}>
        <StyledAvatar imageUrl={imageUrl} name={userName} />
        {userName}
      </Cell>
      <Cell rowEnd rowKey={id}>
        <Invisible hidden={hovered !== id}>
          <RemoveQualityAuditConfigurationButton
            companyId={companyId}
            userId={userId}
          />
        </Invisible>
      </Cell>
    </>
  );
};
